import { EventEmitter, TemplateRef } from '@angular/core';

export interface DropdownPanel {
  templateRef: TemplateRef<unknown>;
  readonly closed: EventEmitter<void>;
}
